module.exports = __webpack_public_path__ + "img/galeria-pacs-clinicas-3.ed34c237.png";